export default __webpack_public_path__ + "static/media/bsIcon2.23231c3d.svg";